<template>
    <div>
        <div class="text-center font-bai" v-if="reservation">
            <h1 class="font-balo font-bold">
                {{ $t("app.Your reservation is confirmed") }}
            </h1>
            <img
                class="order-confirmed"
                src="../../assets/images/confirmation.png"
                alt
            />
            <div class="des">
                {{
                    $t(
                        "app.We have sent a summary of your reservation to the email address provided"
                    )
                }}
                <br />
                {{ $t("app.Nous vous remercions de votre confiance") }}
            </div>
            <router-link to="/" class="btn font-balo font-bold">{{
                $t(`app.Back to the homepage`)
            }}</router-link>
        </div>

        <div class="text-center font-bai" v-if="!reservation">
            <h1 class="font-balo font-bold">
                {{ $t("app.Your reservation failed") }}
            </h1>
            <img
                class="order-confirmed"
                src="../../assets/images/fail.png"
                alt
            />
            <div class="des">
                {{ $t("app.An error occurred during your payment") }}
                <br />
                {{ $t("app.Veuillez recommencer") }}
            </div>
            <router-link to="/" class="btn font-balo font-bold">{{
                $t(`app.Back to the homepage`)
            }}</router-link>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
export default {
    name: "PaymentNotification",
    computed: {
        ...mapState({
            reservation: state => get(state, "cart.reservation")
        })
    },
    methods: {
        ...mapActions("cart", ["setStep"])
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
};
</script>
